export default __webpack_public_path__ + "static/media/css-svg.de88f6dc.png";